export default "../../src/img/Ecolabel_logo-blanc.svg";